export default __webpack_public_path__ + "static/18693-091d5e02b53f59ba56fe1acf2ffe3895.jpg";